import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import DropdownButton from "./DropdownButton";
import Button from "./Button";
import Moment from "./Moment";
import Icon from "./Icon";
import { history } from "../history";

export default class EmailTemplateListItem extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.onClone = this.onClone.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }

  onClone() {
    const { id } = this.props.emailTemplate;
    this.props.onClone(id);
  }

  onDelete() {
    const { id } = this.props.emailTemplate;
    this.props.onDelete(id);
  }

  handleClick() {
    const { id } = this.props.emailTemplate;
    const { accountId } = this.props;
    history.push(`/clients/${accountId}/email-templates/${id}`);
  }

  render() {
    const { id, name, updatedAt, updatedByName, accountId } =
      this.props.emailTemplate;
    return (
      <tr>
        <td onClick={this.handleClick}>{name}</td>
        <td style={{ width: "150px" }} onClick={this.handleClick}>
          {updatedByName}
        </td>
        <td style={{ width: "180px" }} onClick={this.handleClick}>
          <Moment date={updatedAt} />
        </td>
        <td style={{ width: "160px", textAlign: "right" }}>
          <Link to={`/clients/${accountId}/email-templates/${id}`}>
            <Button type="link" title="Edit">
              <Icon icon="pencil" />
            </Button>
          </Link>
          <DropdownButton
            type="link"
            pin="right"
            options={[
              {
                label: "Clone",
                onClick: this.onClone,
              },
              {
                type: "divider",
              },
              {
                label: "Delete",
                onClick: this.onDelete,
              },
            ]}
          />
        </td>
      </tr>
    );
  }
}

EmailTemplateListItem.propTypes = {
  accountId: PropTypes.string.isRequired,
  emailTemplate: PropTypes.object.isRequired,
  onClone: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
